import { Link } from "react-router-dom";

export const Logo = ({ className = "", to = "/" }) => (
  <Link to={to} data-testid="brand-logo" className={`group inline-flex items-center gap-2 font-display text-xl font-extrabold tracking-tight text-white ${className}`}>
    <span className="relative flex h-2.5 w-2.5">
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#ff3b91] opacity-70 animate-ping" />
      <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-[#ff3b91] shadow-[0_0_12px_#ff3b91]" />
    </span>
    <span>visc<span className="text-[#ff3b91] transition-colors group-hover:text-white">.</span>lol</span>
  </Link>
);
